<template>
    <svg
        class="w-6 h-6"
        fill="none"
        stroke-width="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="12"
            cy="12"
            r="8"
            fill="#8b5cf6"
            stroke="#7c3aed"
        />
    </svg>
</template>
